import { StubHubRoutesEnum } from "models/enums/apiRoutes/stubHubApiRoutes";
import { GrossProfitData } from "models/interfaces";
import { IApiBaseResponse } from "models/interfaces/Iglobal";
import { grossProfitType } from "models/types";
import axiosClient from "sharedServices/api/axios.services";

class GrossProfitCancelledService {
    public getGrossProfitData = async (grossProfitRequest: grossProfitType) => {
        return axiosClient.get<
            IApiBaseResponse<GrossProfitData>
        >(StubHubRoutesEnum.GROSS_PROFIT_CANCELLED, {
            params: grossProfitRequest
        });
    };
}

export { GrossProfitCancelledService };